import { trackButtonClick } from '../../common/buildPayloadsTyped/trackButtonClick.js';
import { trackFailedRequest } from '../../common/buildPayloadsTyped/trackFailedRequest.js';
import { isInTwoStepWrapper } from '../../constants.js';
import { trackFacebookAttemptSuccessfulRequest } from './trackFacebookAttemptSuccessfulRequest.js';
export const generateFacebookTrackingPayload = (trackingEventState, formType, checkboxState, activeWrapper, twoStepComponentState) => {
    const standardUniqueNames = {
        registration: 'registerWithFacebook',
        login: 'loginWithFacebook',
    };
    const facebookTrackingEventsPayloads = {
        buttonClick: [
            trackButtonClick,
            {
                uniqueName: isInTwoStepWrapper(activeWrapper)
                    ? 'facebook'
                    : standardUniqueNames[formType],
                ...(isInTwoStepWrapper(activeWrapper) && {
                    componentState: twoStepComponentState,
                }),
            },
        ],
        phoneNumberVerificationError: [
            trackFailedRequest,
            {
                formFailedAttemptsErrors: 'facebookPasswordNotValidPhone',
                ...(isInTwoStepWrapper(activeWrapper) && {
                    componentState: twoStepComponentState,
                }),
            },
        ],
        emailVerificationError: [
            trackFailedRequest,
            {
                formFailedAttemptsErrors: 'facebookAuthenticationFailed',
                ...(isInTwoStepWrapper(activeWrapper) && {
                    componentState: twoStepComponentState,
                }),
            },
        ],
        loginSuccess: [
            trackFacebookAttemptSuccessfulRequest,
            {
                componentState: `consentStayLoggedIn_${checkboxState ? 'checked' : 'unchecked'}`,
                eventName: ['candidateLogin'],
                uniqueName: 'facebookAuthentication',
            },
        ],
        registrationSuccess: [
            trackFacebookAttemptSuccessfulRequest,
            {
                eventName: [
                    'candidateLogin',
                    'candidateAccountCreation',
                    'cvMadeSearchable',
                    'CandidateAccountConfirmation',
                ],
                uniqueName: 'facebookAuthentication',
            },
        ],
    };
    return facebookTrackingEventsPayloads[trackingEventState];
};
//# sourceMappingURL=generateFacebookTrackingPayload.js.map